<template>
  <div class="container">
    <div class="section">
      <div>
        <label class="label widget-label">{{ CONSTANTS.getCopy('WIDGETCODE_COMMON_CSS') }}</label>
        <code class="code-container" lang="css">
          <button v-if="copiedCss" class="copy-button">Copiado al portapapeles</button>
          <button v-else class="copy-button" @click="copyCss">Copiar</button>
          &lt;link href="{{ widgetCssUrl }}" type="text/css" rel="stylesheet"/&gt;
        </code>
      </div>
      <div>
        <label class="label widget-label">{{ CONSTANTS.getCopy('WIDGETCODE_HTML_CODE') }}</label>
        <code class="code-container" lang="html">
          <button v-if="copiedHtml" class="copy-button">{{ CONSTANTS.getCopy('WIDGETCODE_COPY_TO_CLIPBOARD') }}</button>
          <button v-else class="copy-button" @click="copyHtml">{{ CONSTANTS.getCopy('WIDGETCODE_COPY') }}</button>
          &lt;div class="bot-icon"&gt;
          <ul>
            <li>&lt;div class="bot-help" style="background: {{widgetData.backgroundInfoBox}}; color: {{widgetData.infoBoxTextColor}}"&gt;</li>
            <ul>
              <li>&lt;div class="close-container"&gt;&lt;div class="close"&gt;x&lt;/div&gt;&lt;/div&gt;</li>
              <li>{{widgetData.infoBoxText}}</li>
            </ul>
            <li>&lt;/div&gt;</li>
            <li>&lt;div class="avatar-image"&gt;</li>
            <ul><li>&lt;button&gt;&lt;img src="{{widgetData.avatarUrl}}" style="border: {{widgetData.showIconBorderColor ? '2px solid ' + widgetData.iconBorderColor : 'none'}}" class="avatar" alt="{{widgetData.botSubtitle}}"/&gt;&lt;/button&gt;</li></ul>
            <li>&lt;/div&gt;</li>
          </ul>&lt;/div&gt;<br>
          &lt;div id="chat-widget" style="display: none"&gt;
          <ul>
            <li>&lt;div class="header" style="background: {{widgetData.backgroundHeader}}"&gt;</li>
            <ul>
              <!--<li>&lt;img class="avatar" src="{{ widgetData.avatarUrl }}" alt="Avatar"/&gt;</li>-->
              <li>&lt;div class="title-custom-container"&gt;</li>
              <ul>
                <li>&lt;h1 class="title-custom" style="color: {{widgetData.headerTextColor}}"&gt;{{widgetData.botTitle}}&lt;/h1&gt;</li>
                <li>&lt;h2 class="subtitle-custom" style="color: {{widgetData.headerTextColor}}"&gt;{{widgetData.botSubtitle}}&lt;/h2&gt;</li>
              </ul>
              <li>&lt;/div&gt;</li>
              <li>&lt;button id="chat-submenu-button" class="header-button"&gt;&lt;svg width="24" height="24"&gt;</li>
              <ul><li>&lt;path fill="{{widgetData.headerTextColor}}" d="m16.5 11.995c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25z"/&gt;</li></ul>
              <li>&lt;/svg&gt;&lt;/button&gt;</li>
              <li>&lt;div class="chat-submenu" style="display: none"&gt;</li>
              <ul>
                <li>&lt;button id="fullscreen"&gt;{{CONSTANTS.getCopy('WIDGETCODE_FULL_SCREEN')}}&lt;/button&gt;</li>
                <li>&lt;span&gt;{{CONSTANTS.getCopy('WIDGETCODE_FONT_SIZE') + " "}}&lt;button id="fs-S"&gt;A&lt;/button&gt; | &lt;button id="fs-M"&gt;A&lt;/button&gt; | &lt;button id="fs-L"&gt;A&lt;/button&gt;&lt;/span&gt;</li>
                <li>&lt;span&gt;{{CONSTANTS.getCopy('WIDGETCODE_HIGH_CONTRAST') + " "}}&lt;button id="darkmode-on"&gt;ON&lt;/button&gt; | &lt;button id="darkmode-off"&gt;OFF&lt;/button&gt;&lt;/span&gt;</li>
                <li>&lt;button id="delete-chat"&gt;{{CONSTANTS.getCopy('WIDGETCODE_DELETE_CHAT')}}&lt;/button&gt;</li>
              </ul>
              <li>&lt;/div&gt;</li>
              <li>&lt;button id="close-button" class="header-button"&gt;&lt;svg width="24" viewBox="0 0 24 24"&gt;</li>
              <ul><li>&lt;path fill="{{ widgetData.headerTextColor }}" d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/&gt;</li></ul>
              <li>&lt;/svg&gt;&lt;/button&gt;</li>
              <li></li>
            </ul>
            <li>&lt;/div&gt;</li>
            <li>&lt;div class="messages" style="background: {{ widgetData.backgroundMessage }}"&gt;</li>
            <li>&lt;/div&gt;</li>
            <li>&lt;div class="widget-input" style="background: {{widgetData.backgroundFooter}}"&gt;</li>
            <ul>
              <li>&lt;input type="text" style="color: {{widgetData.messageInputTextColor}}; border-color: {{widgetData.messageInputBorderColor}}; background: {{widgetData.backgroundFooter}}" placeholder="{{widgetData.placeholderText}}"/&gt;</li>
              <li>&lt;button class="send-button"&gt;&lt;svg class="send-button" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"&gt;</li>
              <ul><li>&lt;path fill="{{widgetData.sendButtonColor}}" d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"/&gt;</li></ul>
              <li>&lt;/svg&gt;&lt;/button&gt;</li>
            </ul>
            <li>&lt;/div&gt;</li>
          </ul>
          &lt;/div&gt;<br>
          &lt;style&gt;
          <ul>
            <li>#chat-widget .widget-input input::placeholder {color: {{widgetData.messageInputTextColor}}}</li>
            <li v-if="idProject === '4gR073CH'"> #chat-widget .buttons-message .message-button,</li>
            <li v-if="idProject === '4gR073CH'">#chat-widget .buttons-multiselect-message .message-button {</li>
            <ul v-if="idProject === '4gR073CH'"><li>text-align: left;</li></ul>
            <li v-if="idProject === '4gR073CH'">}</li>
          </ul>&lt;/style&gt;
        </code>
      </div>
      <div>
        <label class="label widget-label">{{ CONSTANTS.getCopy('WIDGETCODE_PAGE_SCRIPT') }}</label>
        <code class="code-container" lang="js">
          <button v-if="copiedScriptColors" class="copy-button">{{ CONSTANTS.getCopy('WIDGETCODE_COPY_TO_CLIPBOARD') }}</button>
          <button v-else class="copy-button" @click="copyScriptColors">{{ CONSTANTS.getCopy('WIDGETCODE_COPY') }}</button>
          &lt;script src="{{ widgetJsUrl }}"&gt;&lt;/script&gt;<br>
          &lt;script&gt;
          <ul>
            <li>let botMessageColor = '{{widgetData.botMessageTextColor}}';</li>
            <li>let botLinkColor = '{{widgetData.botLinkTextColor}}';</li>
            <li>let userMessageColor = '{{widgetData.userMessageTextColor}}';</li>
            <li>let botBoxBackground = '{{widgetData.botBoxMessageColor}}';</li>
            <li>let userBoxBackground = '{{widgetData.userBoxMessageColor}}';</li>
            <li>let borderAndTextColorButton = '{{widgetData.borderAndTextColorButton}}';</li>
            <li>let idClient = '{{client ? client : 0}}';</li>
            <li>let idProject = '{{ idProject }}';</li>
            <li>setStartUserMessage('{{ widgetData.startUserMessage }}');</li>
            <li>setStartBotMessage('{{ widgetData.startBotMessage }}');</li>
          </ul>
          &lt;/script&gt;
        </code>
      </div>
    </div>

  </div>
</template>

<script>
import ENV from '../../env'
import CONSTANTS from '../../constants'

export default {
  props: { widgetData: Object, idProject: String },
  name: 'WidgetCode',
  data () {
    return {
      copiedScript: false,
      copiedCss: false,
      copiedHtml: false,
      copiedScriptColors: false,
      client: this.$route.params.client,
      widgetJsUrl: ENV.api.widgetUrl + 'widget.js',
      widgetCssUrl: ENV.api.widgetUrl + 'widget.css'
    }
  },
  methods: {
    copyCss () {
      const code = `<link href="${this.widgetCssUrl}" type="text/css" rel="stylesheet"/>`
      navigator.clipboard.writeText(code).then(() => {
        this.copiedCss = true
        setTimeout(() => { this.copiedCss = false }, 1500)
      })
    },
    copyHtml () {
      let code = '<div class="bot-icon">\n' +
        `<div class="bot-help" style="background: ${this.widgetData.backgroundInfoBox}; color: ${this.widgetData.infoBoxTextColor}">\n` +
        '<div class="close-container"><div class="close">x</div></div>\n' +
        `${this.widgetData.infoBoxText}\n` +
        '</div>\n' +
        '<div class="avatar-image">\n' +
        `<button><img src="${this.widgetData.avatarUrl}" style="border: ${this.widgetData.showIconBorderColor ? '2px solid ' + this.widgetData.iconBorderColor : 'none'}" class="avatar" alt="${this.widgetData.botSubtitle}"/></button>\n` +
        '</div>\n' +
        '</div>\n' +
        '<div id="chat-widget" style="display: none">\n' +
        `<div class="header" style="background: ${this.widgetData.backgroundHeader}">\n` +
        '<div class="title-custom-container">\n' +
        `<h1 class="title-custom" style="color: ${this.widgetData.headerTextColor}">${this.widgetData.botTitle}</h1>\n` +
        `<h2 class="subtitle-custom" style="color: ${this.widgetData.headerTextColor}">${this.widgetData.botSubtitle}</h2>\n` +
        '</div>\n' +
        '<button id="chat-submenu-button" class="header-button"><svg width="24" height="24">\n' +
        `<path fill="${this.widgetData.headerTextColor}" d="m16.5 11.995c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25z"/>\n` +
        '</svg></button>\n' +
        '<div class="chat-submenu" style="display: none">\n' +
        '<button id="fullscreen">' + CONSTANTS.getCopy('WIDGETCODE_FULL_SCREEN') + '</button>\n' +
        '<span>' + CONSTANTS.getCopy('WIDGETCODE_FONT_SIZE') + ' <button id="fs-S">A</button> | <button id="fs-M">A</button> | <button id="fs-L">A</button></span>\n' +
        '<span>' + CONSTANTS.getCopy('WIDGETCODE_HIGH_CONTRAST') + ' <button id="darkmode-on">ON</button> | <button id="darkmode-off">OFF</button></span>\n' +
        '<button id="delete-chat">' + CONSTANTS.getCopy('WIDGETCODE_DELETE_CHAT') + '</button>\n' +
        '</div>\n' +
        '<button id="close-button" class="header-button"><svg width="24" viewBox="0 0 24 24">\n' +
        `<path fill="${this.widgetData.headerTextColor}" d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/>\n` +
        '</svg></button>\n' +
        '</div>\n' +
        `<div class="messages" style="background: ${this.widgetData.backgroundMessage}">\n` +
        '</div>\n' +
        `<div class="widget-input" style="background: ${this.widgetData.backgroundFooter}">\n` +
        `<input type="text" style="--placeholder-color: ${this.widgetData.messageInputTextColor}; color: ${this.widgetData.messageInputTextColor}; border-color: ${this.widgetData.messageInputBorderColor}; background: ${this.widgetData.backgroundFooter}" placeholder="${this.widgetData.placeholderText}"/>\n` +
        '<button class="send-button"><svg class="send-button" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
        `<path fill="${this.widgetData.sendButtonColor}" d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"/>\n` +
        '</svg></button>\n' +
        '</div>\n' +
        '</div>\n' +
        '<style>\n' +
        `#chat-widget .widget-input input::placeholder {color: ${this.widgetData.messageInputTextColor}}\n`
      if (this.idProject === '4gR073CH') {
        code += '#chat-widget .buttons-message .message-button, \n' +
          '#chat-widget .buttons-multiselect-message .message-button {\n' +
          'text-align: left;\n' +
          '}\n'
      }
      code += '</style>'
      navigator.clipboard.writeText(code).then(() => {
        this.copiedHtml = true
        setTimeout(() => { this.copiedHtml = false }, 1500)
      })
    },
    copyScriptColors () {
      // eslint-disable-next-line no-useless-escape
      let code = `<script src="${this.widgetJsUrl}"><\/script>;\n` +
          '<script>\n' +
          `let botMessageColor = '${this.widgetData.botMessageTextColor}';\n` +
          `let botLinkColor = '${this.widgetData.botLinkTextColor}';\n` +
          `let userMessageColor = '${this.widgetData.userMessageTextColor}';\n` +
          `let botBoxBackground = '${this.widgetData.botBoxMessageColor}';\n` +
          `let userBoxBackground = '${this.widgetData.userBoxMessageColor}';\n` +
          `let borderAndTextColorButton = '${this.widgetData.borderAndTextColorButton}';\n` +
          `let idClient = '${this.client ? this.client : 0}';\n` +
          `let idProject = '${this.idProject}';\n` +
          `setStartUserMessage('${this.widgetData.startUserMessage}');\n` +
          `setStartBotMessage('${this.widgetData.startBotMessage}');\n` +
        // eslint-disable-next-line no-useless-escape
        '<\/script>'
      navigator.clipboard.writeText(code).then(() => {
        this.copiedScriptColors = true
        setTimeout(() => { this.copiedScriptColors = false }, 1500)
      })
    }
  }

}
</script>

<style>
  .widget-label {
    margin-top: 1.5rem !important;
  }
  .code-container {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: black;
    background-color: rgba(209,213,219, 1) !important;
    border-radius: 2px;
    padding: 1rem;
    min-height: fit-content;
    max-width: 60vw;
    overflow: auto;
  }
  ul {
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/WidgetCode.vue